import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start User
export const getUsersAdminService = (params) => {
  return http.get(`${base_url}/admin/users`, { params });
};
export const createUserAdminService = (data) => {
  return http.post(`${base_url}/admin/user`, data);
};
export const editUserAdminService = (data) => {
  return http.put(`${base_url}/admin/user/${data.id}`, data);
};
export const changeUserConfirmAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/confirm`);
};
export const changeUserPasswordAdminService = (data) => {
  return http.patch(`${base_url}/admin/user/${data.id}/change-password`, data);
};
export const deleteUserAdminService = (id) => {
  return http.delete(`${base_url}/admin/user/${id}`);
};
export const verifyUserPhoneNumberAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/verify/phone-number`);
};
export const verifyUserEmailAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/verify/email`);
};
export const getUserTokenAdminService = (id) => {
  return http.get(`${base_url}/admin/user/${id}/token`);
};
// End User

// Start Bulk SMS
export const getBulkSMSsAdminService = (params) => {
  return http.get(`${base_url}/admin/bulk-sms`, { params });
};
export const createBulkSMSAdminService = (data) => {
  return http.post(`${base_url}/admin/bulk-sms`, data);
};
export const editBulkSMSAdminService = (data) => {
  return http.put(`${base_url}/admin/bulk-sms/${data.id}`, data);
};
export const deleteBulkSMSAdminService = (id) => {
  return http.delete(`${base_url}/admin/bulk-sms/${id}`);
};
// End Bulk SMS

// Start Order
export const createOrderAdminService = (data) => {
  return http.post(`${base_url}/admin/order`, data);
};
export const sendOrderSMSAdminService = (id) => {
  return http.patch(`${base_url}/admin/order/${id}/sms`);
};
export const deleteOrderAdminService = (id) => {
  return http.delete(`${base_url}/admin/order/${id}`);
};
export const sendOrderSmsAdminService = (data) => {
  return http.post(`${base_url}/admin/orders/send-sms`, data);
};
export const getOrdersAdminService = (onlyActive = true, page = 1, limit = 10, sortBy = "createdAt", sortOrder = "desc") => {
  return http.get(
    `${base_url}/admin/orders?onlyActive=${onlyActive}&page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`
  );
};
export const autoSaveOrderAdminService = (data) => {
  return http.post(`${base_url}/admin/orders/auto-save`, data);
};
export const getOrderLogsAdminService = (orderId) => {
  return http.get(`${base_url}/admin/order/${orderId}/logs`);
};
// End Order
